import React from 'react';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import { injectIntl } from 'react-intl';

class DateInput extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      date: null,
      errorMsg: ''
    };
    this.captureDate = this.captureDate.bind(this);
    this.errorFn = this.errorFn.bind(this);
    this.validFn = this.validFn.bind(this);
  }

  captureDate (date) {
    this.validFn();
    this.setState({
      date
    });
  }

  isValid () {
    let errorFree = true;
    const optional = this.props.optional;
    const val = this.state.date;

    if (!optional && !val) {
      this.errorFn();
      errorFree = false;
    } else {
      this.validFn();
    }

    return errorFree;
  }

  getValue () {
    return this.state.date;
  }

  validFn () {
    this.setState({ errorMsg: '' });
  }

  errorFn () {
    this.setState({ errorMsg: this.props.intl.formatMessage({ id: 'web_2.date_input.enter_date', defaultMessage: 'Please enter a date' }) });
  }

  render () {
    const { date, errorMsg } = this.state;
    return (
      <div>
        <DatePicker
          id="lst-datepkr"
          className={`form-control ${errorMsg ? 'border-error' : ''}`}
          dateFormat="MMM dd, yyyy"
          weekStart="0"
          onChange={this.captureDate}
          selected={date}
          minDate={Moment().toDate()}
          placeholderText="optional"
        />
        {
          errorMsg ? <p className={'help-block inline-help text-danger text-left'}>{errorMsg}</p> : ''
        }
      </div>
    );
  }
}

exports.DateInput = injectIntl(DateInput, { withRef: true });
